import React from 'react'
import { APP_PREFIX_PATH } from 'configs/AppConfig';


export class MagazzinoProtectedRoute {

    static magazzino = [
        {
            key: 'gestisci-magazzini',
            path: `${APP_PREFIX_PATH}/magazzino/gestisci-magazzini`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-magazzini')),
        },
        {
            key: 'gestisci-articoli',
            path: `${APP_PREFIX_PATH}/magazzino/gestisci-articoli`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-articoli')),
        },
        {
            key: 'gestisci-lotti',
            path: `${APP_PREFIX_PATH}/magazzino/gestisci-lotti`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-lotti')),
        },
        {
            key: 'gestisci-gruppi',
            path: `${APP_PREFIX_PATH}/magazzino/gestisci-gruppi`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-gruppi')),
        },
        {
            key: 'gestisci-fornitori',
            path: `${APP_PREFIX_PATH}/magazzino/gestisci-fornitori`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-fornitori')),
        },
        {
            key: 'gestisci-ddt',
            path: `${APP_PREFIX_PATH}/magazzino/gestisci-ddt`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-ddt')),
        },
        {
            key: 'scheda-articolo',
            path: `${APP_PREFIX_PATH}/scheda-articolo/:id`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-articoli/scheda-articolo')),
        },
        {
            key: 'scheda-fornitore',
            path: `${APP_PREFIX_PATH}/scheda-fornitore/:id`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-fornitori/scheda-fornitore')),
        },
        {
            key: 'scheda-lotto',
            path: `${APP_PREFIX_PATH}/scheda-lotto/:id`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-lotti/scheda-lotto')),
        },
        {
            key: 'scheda-magazzino',
            path: `${APP_PREFIX_PATH}/scheda-magazzino/:id`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-magazzini/scheda-magazzino')),
        },
        {
            key: 'scheda-ddt',
            path: `${APP_PREFIX_PATH}/scheda-ddt/:id`,
            component: React.lazy(() => import('views/magazzino-views/magazzino/gestione-ddt/scheda-ddt')),
        },
    ]

    static getNavTree() {
        return this.magazzino;
    }

}

export default MagazzinoProtectedRoute;
